import { apiRequest } from '../core/http';
import type {
  UsageMembersParams,
  UsageMembersResponse,
  UsagePeriodsParams,
  UsagePeriodsResponse,
  UsageSummaryParams,
  UsageSummaryResponse,
  UsageTeamsParams,
  UsageTeamsResponse,
} from './usage.types';

/** Drops empty values so the server applies its defaults. */
function clean(params: Record<string, string | number | undefined>) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== '')
  );
}

export function getUsageSummary(p: UsageSummaryParams) {
  return apiRequest<UsageSummaryResponse>('get', '/v1/usage/summary', undefined, {
    params: clean({ ...p }),
  });
}

export function getUsagePeriods(p: UsagePeriodsParams) {
  return apiRequest<UsagePeriodsResponse>('get', '/v1/usage/periods', undefined, {
    params: clean({ ...p }),
  });
}

export function getUsageMembers(p: UsageMembersParams) {
  const { userUuids, ...rest } = p;
  return apiRequest<UsageMembersResponse>('get', '/v1/usage/members', undefined, {
    params: clean({ ...rest, userUuids: userUuids?.length ? userUuids.join(',') : undefined }),
  });
}

export function getUsageTeams(p: UsageTeamsParams) {
  return apiRequest<UsageTeamsResponse>('get', '/v1/usage/teams', undefined, {
    params: clean({ ...p }),
  });
}